/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Created
 *
 * 1 = Authorised
 *
 * 2 = Sent
 *
 * 3 = Confirmed
 *
 * 4 = Declined
 *
 * 5 = Cancelled
 *
 * 6 = Differed
 */
export enum RepairOrderQuoteStatusEnum {
  Created = 0,
  Authorised = 1,
  Sent = 2,
  Confirmed = 3,
  Declined = 4,
  Cancelled = 5,
  Differed = 6,
}
